import { authGet } from './authMiddleware';

export const getCompanyFolders = async (EntityId) => {
    return authGet('/api/portfolio/folder?EntityId=' + EntityId);
}